/**
 * The amount of degrees in circle
 */
export const CIRCLE_DEGREES: number = 360;

/**
 * The gradient angle start point ratio
 */
export const START_POINT_RATIO: number = 0;

/**
 * The gradient angle end point ratio
 */
export const END_POINT_RATIO: number = 1;

/**
 * The epsilon value for floating point comparisons
 */
export const EPSILON: number = 0.000001;
